// Reps mix up {driver_name} and {{driver_name}}; MDXEditor also saves the underscore as \_.
const DRIVER_NAME_RE = /\{\{?\s*driver\\?_name\s*\}?\}/g

export function fillDriverName(text: string, driverName: string): string {
  return text.replace(DRIVER_NAME_RE, () => driverName)
}
